// extracted by mini-css-extract-plugin
export default {"swiper":"styles_swiper__R8Xkh","header":"styles_header__4jMok","navigation":"styles_navigation__uv9FY","paginationContainer":"styles_paginationContainer__fZGgj"};